import React, { useState } from "react";
import toast from "react-hot-toast";
import { useFirestoreAdmin } from "../context/FirestoreAdminProvider";
import { smartSearch } from "../services/smartSearchService";
import { trackRead } from "../services/monitorService";

export default function GlobalSearchPage() {
  const { allCollections } = useFirestoreAdmin();
  const [term, setTerm] = useState("");
  const [mode, setMode] = useState("partial");
  const [searchIn, setSearchIn] = useState({ id: true, field: true, value: true });
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const run = async () => {
    if (!term.trim()) return;
    setLoading(true);
    try {
      const inList = Object.entries(searchIn).filter(([, v]) => v).map(([k]) => k);
      const rows = await smartSearch({
        searchTerm: term,
        collections: allCollections,
        mode,
        searchIn: inList,
        perCollection: 40,
      });
      trackRead(rows.length);
      setResults(rows);
      toast.success(`Found ${rows.length} match(es)`);
    } catch (e) {
      toast.error(e?.message || "Search failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-2xl font-bold">Smart Search</h1>
        <p className="text-sm text-slate-600">Search document IDs, field names, and values across every registered collection.</p>
      </header>
      <div className="fa-card space-y-3 p-4">
        <input
          className="w-full rounded-lg border px-3 py-2 text-sm"
          placeholder="Search term…"
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && run()}
        />
        <div className="flex flex-wrap gap-4 text-sm">
          <select className="rounded-lg border px-2 py-1" value={mode} onChange={(e) => setMode(e.target.value)}>
            <option value="partial">Partial match</option>
            <option value="exact">Exact match</option>
          </select>
          {["id", "field", "value"].map((k) => (
            <label key={k} className="flex items-center gap-1">
              <input type="checkbox" checked={searchIn[k]} onChange={(e) => setSearchIn({ ...searchIn, [k]: e.target.checked })} />
              {k}
            </label>
          ))}
        </div>
        <button type="button" className="fa-btn fa-btn-primary" onClick={run} disabled={loading}>
          {loading ? "Searching…" : "Search all collections"}
        </button>
      </div>
      <div className="fa-card fa-table-wrap">
        <table className="fa-table">
          <thead>
            <tr>
              <th>Collection</th>
              <th>Document</th>
              <th>Matched field</th>
              <th>Matched value</th>
            </tr>
          </thead>
          <tbody>
            {results.map((r, i) => (
              <tr key={`${r.collection}-${r.id}-${i}`}>
                <td>{r.collection}</td>
                <td className="font-mono text-xs">{r.id}</td>
                <td>{r.matchedField}</td>
                <td className="max-w-md truncate text-xs">{r.matchedValue}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
